<template>
  <b-container>
    <div v-if="buildings.length > 0">
      <b-row class="mt-4">
        <b-col sm="4">
          <b-form-select v-model="building" :options="buildings" v-on:change="OnBuildingClick"></b-form-select>
          <div class="text-danger" v-if="!$v.building.required && $v.building.$dirty">
            {{ $t("info.required") }}
          </div>
        </b-col>
      </b-row>

      <div v-if="taskListTable.length > 0" class="mt-2">
        <b-button v-b-toggle.collapse-1 variant="outline-info">{{ $t('label.numberOfTaskNotFound') }} ({{
          infoTaskError.length }})</b-button>
        <b-collapse id="collapse-1" class="mt-2">
          <b-alert v-if="infoTaskError.length > 0" show variant="info" class="mt-2">
            <strong>{{ $t('info.openTaskNoTFound') }}</strong>
            <ul class="mt-2">
              <li v-for="task in infoTaskError" v-bind:key="task.Id">
                {{ task.Title }}
              </li>
            </ul>
          </b-alert>
        </b-collapse>
        <b-row class="pt-2">
          <b-col sm="4" class="mt-2">
            <b-form-select v-model="perPage" :options="options"></b-form-select>
          </b-col>
          <b-col sm="4" class="mt-2">
            <b-form-input v-model="search" :placeholder="$t('action.search')"></b-form-input>
            <b-button variant="link" @click="resetTable()">{{
              $t("action.reset")
              }}</b-button>
          </b-col>
          <b-col sm="4" class="mt-2">
            <div>{{ $t("label.tablesize") }} {{ rows }}</div>
          </b-col>
        </b-row>

        <b-row class="pt-4">
          <b-col class="lgTable">
            <b-table id="taskListTable" stacked="lg" bordered :fields="myfields" :items="items" :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc" :per-page="perPage" :current-page="currentPage">
            </b-table>
          </b-col>
        </b-row>

        <b-row class="pt-4">
          <b-col sm="6" class="mt-2">
            <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"
              aria-controls="taskListTable"></b-pagination>
          </b-col>
        </b-row>
      </div>
    </div>

    <div v-if="spinner" class="text-center">
      <b-spinner style="width: 3rem; height: 3rem" class="spinner" variant="success" label="Spinning"
        disabled="labelStatus"></b-spinner>
    </div>

    <div v-if="error" class="pt-4">
      <b-alert show variant="danger">
        <p>{{ error }}</p>
      </b-alert>
    </div>
  </b-container>
</template>

<script>
import moment from "moment";
import axios from "axios";
import { globalF } from "../../Helpers";
import { required } from "vuelidate/lib/validators";

export default {
  mixins: [globalF],
  data() {
    return {
      taskEvent: [],
      taskTable: null,
      taskRadio: null,
      success: false,
      error: "",
      spinner: false,
      task: null,
      taskList: [],
      taskListTable: [],
      rawData: [],
      teamsGroup: [],
      teamBuildings: [],
      buildings: [],
      building: null,
      sortBy: "createdDateTime",
      sortDesc: true,
      perPage: 10,
      currentPage: 1,
      search: "",
      options: [
        { value: 10, text: "10" },
        { value: 25, text: "25" },
        { value: 50, text: "50" },
        { value: 100, text: "100" },
      ],
      teamSelect: null,
      existingTeamForBuilding: false,
      newGroupName: "",
      teamPlan: null,
      teamBucket: null,
      memberOf: [],
      infoTaskError: []
    };
  },
  validations() {
    return {
      building: {
        required,
      },
    };
  },
  mounted() {
    this.getTeamBuildingTaskList();
  },
  watch: {},
  computed: {
    user: function () {
      return this.$store.getters.getUser;
    },
    url: function () {
      return this.getUrl();
    },
    rows() {
      return this.items.length;
    },
    items: function () {
      let mydatalist = this.taskListTable;
      let search = this.search.toLowerCase();
      return mydatalist.filter(
        (p) =>
          p.buildingName.toString().toLowerCase().includes(search) ||
          p.groupName.toString().toLowerCase().includes(search) ||
          p.createdDateTime.toLowerCase().includes(search) ||
          p.dueDateTime.toLowerCase().includes(search) ||
          p.completedDateTime.toLowerCase().includes(search) ||
          p.displayName.toLowerCase().includes(search)
      );
    },
    myfields: function () {
      return [
        {
          key: "title",
          sortable: true,
          label: this.$t("label.taskName"),
        },
        {
          key: "displayName",
          sortable: true,
          label: this.$t("title.user")
        },
        {
          key: "createdDateTime",
          sortable: true,
          label: this.$t("label.createdDateTime"),
          formatter: (value) => {
            return value ? moment(value).format("YYYY-MM-DD HH:mm:ss") : "";
          },
        },
        {
          key: "dueDateTime",
          sortable: true,
          label: this.$t("label.dueDateTime"),
          formatter: (value) => {
            return value ? moment(value).format("YYYY-MM-DD HH:mm:ss") : "";
          },
        },
        {
          key: "completedDateTime",
          sortable: true,
          label: this.$t("label.completedDateTime"),
          formatter: (value) => {
            return value ? moment(value).format("YYYY-MM-DD HH:mm:ss") : "";
          },
        },
        {
          key: "completedByUser",
          sortable: true,
          label: this.$t("label.completedBy"),
          formatter: (value) => {
            return this.getDisplayName(value);
          },
        }
      ];
    },
  },
  methods: {
    openModal: function (id, taskTable) {
      if (taskTable) {
        this.taskTable = taskTable;
      }
      this.$bvModal.show(id);
    },
    getAssignements(taskList) {
      let keyList = [];

      let assignments = taskList.assignments;

      if (assignments) {
        for (const [key] of Object.entries(assignments)) {
          keyList.push(key);
        }
      }

      return keyList;
    },
    getTeamBuildingTaskList() {
      this.spinner = true;
      let urls = this.$store.getters.getUrlsList;
      let url = urls[process.env.VUE_APP_WHERE].json;
      let destination = this.getDestinationByUserRole(this.user.role);

      let promise = this.validateToken();
      promise.then(() => {
        axios
          .post(
            url,
            { request: "getTeamBuildingTaskList", destination: destination },
            { headers: { "Content-Type": "application/json" } }
          )
          .then((response) => {
            this.spinner = false;
            this.teamBuildings = response.data.teamBuildings;
            this.taskEvent = response.data.taskEvent;
            this.setBuildingsList(response.data.buildings);
          })
          .catch(() => {
            this.spinner = false;
            this.error = this.$t("info.errorgeneric");
          });
      });
    },
    setBuildingsList: function (buildings) {
      this.buildings = buildings.map((b) => {
        return {
          text: b.NOMDIV,
          value: b,
        };
      });

      this.buildings.sort(function (a, b) {
        if (a.text < b.text) {
          return -1;
        }
        if (a.text > b.text) {
          return 1;
        }
        return 0;
      });

      this.buildings.unshift({
        text: this.$t("label.properties"),
        value: null,
      });
    },
    resetTable: function () {
      this.search = "";
    },
    OnBuildingClick: function () {
      if (this.building) {
        this.taskListTable = [];
        this.error = "";
        this.spinner = true;
        this.getTaskBuilding();
      }
    },
    getTaskBuilding: function () {

      let obj = {
        request: "getTaskBuilding",
        idBuilding: this.building.Id,
        destination: this.getDestinationByUserRole(this.user.role)
      };
      axios
        .post(this.url, obj, {
          headers: { "Content-Type": "application/json" },
        })
        .then((response) => {
          let taskBuilding = response.data;
          if (taskBuilding.length > 0) {
            this.setPlannerTasksList(taskBuilding);
          }
          else {
            this.spinner = false;
          }
        })
        .catch(() => {
          this.spinner = false;
          this.error = this.$t("info.errorgeneric");
        });
    },
    setPlannerTasksList(taskBuilding) {
      let token = this.getGlobalData("accessToken");

      let request = [];

      for (let i = 0; i < taskBuilding.length; i++) {
        let IdTaskGraph = taskBuilding[i].IdTaskMicrosoft;

        //let graphEndPoint = `https://graph.microsoft.com/v1.0/planner/tasks/${IdTaskGraph}`;
        let graphEndPoint = `https://graph.microsoft.com/beta/planner/tasks/${IdTaskGraph}`;

        request.push(this.getPlannerTasks(token, graphEndPoint));
      }

      Promise.allSettled(request).then((results) => {
        this.spinner = false;
        let successList = results.filter((r) => r.status === "fulfilled");
        if (successList.length > 0) {
          this.setTaskBuilding(successList, taskBuilding);
        }

        let errorList = results.filter((r) => r.status === "rejected");
        if (errorList.length > 0) {
          this.getInfoTaskError(successList, taskBuilding);
          this.logError(errorList);
        }
      });
    },
    getInfoTaskError(successList, taskBuilding) {
      let taskEvent = this.taskEvent;

      let taskError = taskBuilding.filter(t => {
        let found = successList.find((s) => t.IdTaskMicrosoft === s.value.data.id)
        if (!found) {
          return t;
        }
      });

      this.infoTaskError = taskEvent.filter(t => {
        let found = taskError.find((s) => t.Id == s.IdTaskEvent)
        if (found) {
          return t;
        }
      })
    },
    getMemberOf(token, groupId) {
      let graphEndpoint = `https://graph.microsoft.com/v1.0/groups/${groupId}/members`;
      return axios.get(graphEndpoint, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          ConsistencyLevel: "eventual",
        },
      });
    },
    getPlannerTasks(token, graphEndpoint) {
      return axios.get(graphEndpoint, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
    },
    setTaskBuilding(successList, taskBuilding) {
      this.spinner = false;
      let teamBuildings = this.teamBuildings;
      let completedByUserList = [];

      let taskList = successList.map((s) => {
        let taskList = s.value.data;
        let taskBuildingItem = taskBuilding.find(t =>
          t.IdTaskMicrosoft === taskList.id
        );

        taskList.displayName = taskBuildingItem ? taskBuildingItem.DisplayName : "";

        taskList.groupName = "";
        taskList.buildingName = this.building.NOMDIV;
        let teamBuilding = teamBuildings.find(
          (t) => t.IdBuilding === this.building.Id
        );
        if (teamBuilding) {
          taskList.groupName = teamBuilding.GroupName;
        }
        taskList._cellVariants = this.setCellVariants(taskList);
        taskList.assigmentsKey = this.getAssignements(taskList);
        if (taskList.completedBy) {
          completedByUserList.push(taskList.completedBy.user.id);
        }
        taskList.completedByUser = taskList.completedBy
          ? taskList.completedBy.user.id
          : "";
        return taskList;
      });

      if (completedByUserList.length > 0) {
        this.getUsers(completedByUserList, taskList);
      } else {
        this.taskListTable = taskList;
      }
    },
    getUsers(completedByUserList, taskList) {
      let token = this.getGlobalData("accessToken");

      let request = [];

      for (let i = 0; i < completedByUserList.length; i++) {
        let userId = completedByUserList[i];
        request.push(this.getUserById(token, userId));
      }

      Promise.allSettled(request).then((results) => {
        this.spinner = false;
        let successList = results.filter((r) => r.status === "fulfilled");
        if (successList.length > 0) {
          this.memberOf = successList.map((r) => r.value.data);
          this.taskListTable = taskList;
        }

        let errorList = results.filter((r) => r.status === "rejected");
        if (errorList.length > 0) {
          this.logError(errorList);
        }
      });
    },
    getUserById(token, idUser) {
      let graphEndpoint = `https://graph.microsoft.com/v1.0/users/${idUser}`;
      return axios.get(graphEndpoint, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
    },
    getDisplayName(idUser) {
      let memberOf = this.memberOf;
      let displayName = "";
      if (memberOf.length > 0) {
        let member = memberOf.find((m) => m.id === idUser);
        if (member) {
          displayName = member.displayName;
        }
      }
      return displayName;
    },
    setCellVariants(taskList) {
      let now = moment().format("YYYY-MM-DD HH:mm:ss");
      let dueDateTime = taskList.dueDateTime
        ? moment(taskList.dueDateTime).format("YYYY-MM-DD HH:mm:ss")
        : null;
      let completedDateTime = taskList.completedDateTime
        ? moment(taskList.completedDateTime).format("YYYY-MM-DD HH:mm:ss")
        : null;

      let taskStatusObj = { dueDateTime: "" };
      if (completedDateTime) {
        taskStatusObj = { completedDateTime: "success" };
      } else if (dueDateTime < now) {
        taskStatusObj = { dueDateTime: "danger" };
      } else if (dueDateTime > now) {
        taskStatusObj = { dueDateTime: "warning" };
      } else {
        taskStatusObj = { dueDateTime: "" };
      }

      return taskStatusObj;
    },
    logError(errorList) {
      let obj = {
        request: "logError",
        jobName: "TaskByBuilding",
        errorList: errorList,
      };
      axios
        .post(this.url, obj, {
          headers: { "Content-Type": "application/json" },
        })
        .then(() => {
          this.spinner = false;
        })
        .catch(() => {
          this.spinner = false;
          this.error = this.$t("info.errorgeneric");
        });
    },
  },
  components: {},
};
</script>
